import { Routes, Route } from 'react-router-dom'
import { Layout } from 'features/common/layout'
import MainPage from 'pages/main/page'
import { routes } from 'core/routes/paths'

export const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path={routes.main} element={<MainPage />} />
                {/*<Route path="*" element={<NotFoundPage />} />*/}
            </Route>
        </Routes>
    )
}
